import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { articles } from '../mock';

const Blog = () => {
  return (
    <main className="blog-container">
      <div className="blog-header">
        <h1 className="page-title">Guides & Articles</h1>
        <p className="page-subtitle">
          Découvrez nos guides complets et articles de fond sur la lithothérapie, les chakras et l'utilisation des pierres naturelles.
        </p>
      </div>

      <div className="articles-list">
        {articles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="article-item card"
          >
            <div className="article-image-container">
              <img src={article.image} alt={article.titre} className="article-image" />
              <div className="article-category-badge">{article.categorie}</div>
            </div>

            <div className="article-body">
              <h2 className="article-heading">{article.titre}</h2>
              <p className="article-description">{article.extrait}</p>

              <div className="article-footer">
                <div className="article-metadata">
                  <span className="metadata-item">
                    <Calendar size={16} />
                    {new Date(article.date).toLocaleDateString('fr-FR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </span>
                  <span className="metadata-item">
                    <Clock size={16} />
                    {article.tempsDeLecture}
                  </span>
                </div>
                <span className="read-more">
                  Lire l'article <ArrowRight size={18} />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <style jsx>{`
        .blog-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 3rem 2rem;
          min-height: 80vh;
        }

        .blog-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .page-title {
          font-size: 3rem;
          color: #1a365d;
          margin-bottom: 1rem;
          font-weight: 600;
        }

        .page-subtitle {
          font-size: 1.15rem;
          color: #4a5568;
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.7;
        }

        .articles-list {
          display: flex;
          flex-direction: column;
          gap: 2.5rem;
        }

        .article-item {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          text-decoration: none;
          display: grid;
          grid-template-columns: 400px 1fr;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
        }

        .article-image-container {
          position: relative;
          overflow: hidden;
          background: #f7fafc;
        }

        .article-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .article-item:hover .article-image {
          transform: scale(1.05);
        }

        .article-category-badge {
          position: absolute;
          top: 1.5rem;
          left: 1.5rem;
          background: rgba(45, 90, 140, 0.95);
          color: white;
          padding: 0.5rem 1.25rem;
          border-radius: 25px;
          font-size: 0.9rem;
          font-weight: 600;
        }

        .article-body {
          padding: 2.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .article-heading {
          font-size: 1.85rem;
          color: #1a365d;
          margin-bottom: 1rem;
          font-weight: 600;
          line-height: 1.3;
        }

        .article-description {
          color: #4a5568;
          line-height: 1.7;
          margin-bottom: 2rem;
          flex: 1;
        }

        .article-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 1.5rem;
          border-top: 1px solid #e2e8f0;
        }

        .article-metadata {
          display: flex;
          gap: 1.5rem;
          flex-wrap: wrap;
        }

        .metadata-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #718096;
          font-size: 0.9rem;
        }

        .read-more {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #2d5a8c;
          font-weight: 600;
          transition: gap 0.2s ease;
        }

        .article-item:hover .read-more {
          gap: 0.75rem;
        }

        @media (max-width: 768px) {
          .blog-container {
            padding: 2rem 1.5rem;
          }

          .page-title {
            font-size: 2rem;
          }

          .page-subtitle {
            font-size: 1rem;
          }

          .article-item {
            grid-template-columns: 1fr;
          }

          .article-image-container {
            padding-top: 56%;
            position: relative;
          }

          .article-image {
            position: absolute;
            top: 0;
            left: 0;
          }

          .article-body {
            padding: 1.75rem;
          }

          .article-heading {
            font-size: 1.5rem;
          }

          .article-footer {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }
        }
      `}</style>
    </main>
  );
};

export default Blog;